'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react.production.min.js');
} else {
  module.exports = require('./cjs/react.development.js');
}



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react/index.js
// module id = 0
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16